import { create } from 'zustand';

type GlobalLoadingStore = {
  isShow: boolean;
  showLoading: () => void;
  hideLoading: () => void;
};

const useGlobalLoadingStore = create<GlobalLoadingStore>((set) => ({
  isShow: false,
  showLoading: () => set(() => ({ isShow: true })),
  hideLoading: () => set(() => ({ isShow: false })),
}));

export const useGlobalLoading = () => {
  const isShow = useGlobalLoadingStore((state) => state.isShow);

  return {
    isShow,
  };
};

export const useGlobalLoadingHandler = () => {
  const showLoading = useGlobalLoadingStore((state) => state.showLoading);
  const hideLoading = useGlobalLoadingStore((state) => state.hideLoading);

  return {
    showLoading,
    hideLoading,
  };
};
